import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import LogoutContent from '../LogoutContent';
import apiBase from '../../../apiConfig';
import AppContext from '../../../context/Context';

const Logout = () => {
  const { clearAuth } = useContext(AppContext);
  const [isComplete, setIsComplete] = useState(false);

  useEffect(() => {
    const runLogout = async () => {
      try {
        await axios.post(`${apiBase}/p-admin/auth.php?action=logout`);
      } catch (error) {
        // Client-side auth state is still cleared below.
      } finally {
        clearAuth();
        setIsComplete(true);
      }
    };

    runLogout();
  }, [clearAuth]);

  if (isComplete) {
    return <Redirect to="/authentication/basic/login?panel=admin" />;
  }

  return (
    <div className="text-center">
      <LogoutContent />
    </div>
  );
};

export default Logout;
